// Copyright 2020 TOKU Systems Inc.
import { createContainer } from 'victory';
import React from 'react';

const ZoomCursorContainer = createContainer(
  'zoom',
  'cursor'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) as React.ComponentType<any>;

export default ZoomCursorContainer;
